import { Link } from "react-router-dom";
import AuthImage, { externalFileUrl } from "./AuthImage";
import { User, Shield } from "lucide-react";

export default function AuthorChip({ author, timestamp }) {
  const isOrg = author?.type === "org";
  const href = author?.handle ? `/u/${author.handle}` : (isOrg ? `/org/${author.id}` : `/profile/${author.id}`);
  return (
    <Link to={href} className="flex items-center gap-3 group" data-testid={`author-chip-${author?.handle || author?.id}`}>
      <div
        className="w-10 h-10 rounded-full overflow-hidden border border-[rgba(0,170,255,0.18)]"
        style={{ boxShadow: isOrg ? "0 0 12px rgba(0, 170, 255,0.25)" : "0 0 12px rgba(57, 255, 20,0.18)" }}
      >
        <AuthImage
          src={author?.avatar_url}
          alt={author?.name || ""}
          className="w-full h-full object-cover"
          fallback={
            <div className="w-full h-full flex items-center justify-center bg-[#0d1b2e]">
              {isOrg ? <Shield size={14} className="text-[#00aaff]" /> : <User size={14} className="text-[#39ff14]" />}
            </div>
          }
        />
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm text-white group-hover:text-[#00aaff] truncate">{author?.name}</span>
          {isOrg && (
            <span className="font-mono-tech text-[9px] uppercase tracking-[0.22em] px-1.5 py-0.5 rounded bg-[#00aaff]/10 text-[#00aaff]">Org</span>
          )}
        </div>
        <div className="font-mono-tech text-[11px] text-[#94a3b8] truncate">
          @{author?.handle} · {timestamp ? new Date(timestamp).toLocaleString() : ""}
        </div>
      </div>
    </Link>
  );
}
